import { useState } from 'react'
import { ModalBtn } from './ModalBtn'
import { useCreateSupplier } from '../../api/useSupplier'
import { Grower, GrowersList } from '../../interfaces/interfaces.auth'
import { useDispatch } from 'react-redux'
import { startChecking } from '../../store/asyncMethods/authMethods'
import { hasLength } from '../../helpers/validators'
import toast from 'react-hot-toast'
import { useCreateGrower, useEditGrower } from '../../api/useGrower'

interface Props {
    target: GrowersList
    closeModal: () => void
    grower?: Grower
}

export const ModalAddGrower = ({ closeModal, target, grower }: Props) => {

    const dispatch = useDispatch()

    const [name, setName] = useState(grower?.name || "")
    const [ggn_number, setGGN_number] = useState(grower?.ggn_number || "")

    const { mutate, isLoading } = useCreateGrower()
    const { mutate: mutateEditGrower, isLoading: isEditing } = useEditGrower()

    const addGrower = () => {

        const cleanGGN = ggn_number.trim()
        const cleanName = name.trim()

        // if (target.growers.find(grower => grower.ggn_number === cleanGGN || grower.name.trim() === cleanName)) return toast.error("Grower already exists")
        if ((grower
            ? target.growers.filter(g => g.name !== grower.name || g.ggn_number !== grower.ggn_number)
            : target.growers
        ).find(grower => grower.ggn_number === cleanGGN || grower.name.trim() === cleanName)) return toast.error("Grower already exists")
        if (!hasLength(ggn_number) || !hasLength(name)) return toast.error("Please fill in all fields")

        const payload = {
            id: target.id,
            model: target.model,
            ggn_number: cleanGGN,
            name: cleanName
        }

        grower
        ?
        mutateEditGrower({...payload, growerId: grower._id}, {
            onSuccess: () => {
                dispatch(startChecking())
                closeModal()
            },
            onError: (error) => console.log(error)
        })
        :
        mutate(payload, {
            onSuccess: () => {
                dispatch(startChecking())
                closeModal()
            },
            onError: (error) => console.log(error)
        })
    };

    return (

        <div className="modal">

            <div className="modal__card">
                <div className="modal__content">

                    <p className='font-normal mb-02 ml-02'>Name</p>
                    <input
                        className="mb-1"
                        type="text"
                        value={name}
                        maxLength={20}
                        onChange={(e) => setName(e.target.value)}
                    />
                    <>
                        <p className='mt-1 font-normal mb-02 ml-02'>GGN Number</p>
                        <input
                            type="text"
                            value={ggn_number}
                            maxLength={20}
                            onChange={(e) => setGGN_number(e.target.value.toUpperCase())}
                        />
                    </>

                    <ModalBtn
                        action={addGrower}
                        closeModal={closeModal}
                        actionTitle={`${grower ? 'Edit Grower' : 'Add Grower'}`}
                        isLoading={isLoading || isEditing}
                    />

                </div>
            </div>
        </div>

    )
}
